const initialState = {
    isModalVisible: false,
  };
  
  const financeModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_FINANCE_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_FINANCE_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default financeModalReducer;
  